export const typography = {
  fontFamily: "'Roboto', sans-serif",
  h1: {
    fontSize: '2rem',
    lineHeight: 1,
    fontWeight: 700,
    fontFamily: "'Roboto Condensed', sans-serif",
  },
  h2: {
    fontSize: '3.5rem',
    lineHeight: '4rem',
    fontWeight: 700,
    color: '#fff',
    fontFamily: "'Roboto Condensed', sans-serif",
  },
  h3: {
    fontSize: '2.5rem',
    lineHeight: '3rem',
    fontWeight: 700,
    fontFamily: "'Roboto Condensed', sans-serif",
  },
  h4: {
    fontSize: '1.5rem',
    lineHeight: 1.5,
    fontWeight: 700,
    fontFamily: "'Roboto Condensed', sans-serif",
  },
  h5: {
    fontSize: '1.25rem',
    lineHeight: '1.5rem',
    fontWeight: 700,
    fontFamily: "'Roboto Condensed', sans-serif",
  },
  h6: {
    fontSize: '1rem',
    lineHeight: 1.125,
    fontWeight: 500,
    fontFamily: "'Roboto Condensed', sans-serif",
  },
  subtitle1: {
    fontWeight: '500',
    lineHeight: 2,
    fontSize: '1rem',
  },
  subtitle2: {
    fontWeight: '500',
    lineHeight: 1.5,
    fontSize: '1rem',
  },
  body1: {
    fontSize: '1rem',
  },
  body2: {
    fontSize: '1.125rem',
    lineHeight: '2rem',
  },
  overline: {
    fontSize: '1rem',
  },
}
